// UserPermissionGroup.tsx
import { Box } from '@mui/material';
import CustomNoRowsOverlay from '@/components/CustomNoRowsOverlay';
import AppDataGrid from '@/components/DataGrid/AppDataGrid';
import { UserListsSchema } from '@/zod_schemas';
import useGetUserColumns from '../Permissions/Grid/useGetUserColumns';

const customMessage = 'No user in the group'; // Example custom message

// Define a functional component to use as the overlay
const NoRowsOverlay = () => <CustomNoRowsOverlay message={customMessage} />;

interface UserPermissionGroupProps {
  page?: string;
  data: UserListsSchema[];
  assignUserGroup?: (id: string) => void;
  removeUserGroup?: (id: string) => void;
  setRemoveSelectedRowIds?: React.Dispatch<
    React.SetStateAction<(string | number)[]>
  >;
}
const UserPermissionGroup = ({
  page,
  data,
  assignUserGroup,
  removeUserGroup,
  setRemoveSelectedRowIds,
}: UserPermissionGroupProps) => {
  const columns = useGetUserColumns({ page, assignUserGroup, removeUserGroup });

  return (
    <Box sx={{ width: '100%' }}>
      <AppDataGrid
        rows={data}
        columns={columns}
        onRowSelectionModelChange={(ids) => {
          if (setRemoveSelectedRowIds) {
            setRemoveSelectedRowIds(ids);
          }
        }}
        initialState={{
          pagination: {
            paginationModel: {
              pageSize: 5,
            },
          },
        }}
        pageSizeOptions={[5]}
        checkboxSelection
        disableRowSelectionOnClick
        slots={{
          noRowsOverlay: NoRowsOverlay,
        }}
        sx={{ border: 0, borderRadius: 0, minHeight: 320 }}
      />
    </Box>
  );
};

export default UserPermissionGroup;
